import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icons/reset.svg'
import _imports_1 from '@/assets/img/icons/cancel-blue.svg'
import _imports_2 from '@/assets/img/icons/save-black.svg'


const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "text-xl text-blue-900 mb-4 font-semibold" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "border border-gray-200 shadow-md rounded-xl overflow-hidden bg-gray-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white p-4 text-gray-400 text-center" }, "Preview email", -1)
const _hoisted_10 = { class: "p-4 pb-0" }
const _hoisted_11 = { class: "bg-white px-8 py-4 pb-16" }
const _hoisted_12 = { class: "bg-gray-100 py-2 px-4 text-center" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 py-2 px-4 text-center h-10" }, null, -1)
const _hoisted_15 = { class: "relative h-16" }
const _hoisted_16 = { class: "flex justify-end gap-3 w-full bg-white border-t fixed bottom-0 left-0 p-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_label = _resolveComponent("input-label")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.emailTemplateIdParam ? "Edit Template" : "Buat Template Baru"), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_input_label, {
            label: "Nama Template",
            isRequired: true
          }),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            class: "p-2 border rounded w-full"
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_input_label, {
            label: "Header Email",
            isRequired: true
          }),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.header) = $event)),
            class: "p-2 border rounded w-full"
          }, null, 512), [
            [_vModelText, _ctx.header]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_input_label, {
            label: "Isi Email",
            isRequired: true
          }),
          _createVNode(_component_editor, {
            theme: "snow",
            content: _ctx.body,
            "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body) = $event)),
            "content-type": "html"
          }, null, 8, ["content"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.header || "HEADER"), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.body,
                class: "py-4 no-style"
              }, null, 8, _hoisted_13),
              _hoisted_14
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
          class: "px-4 py-2 bg-transparent rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, [
          _hoisted_17,
          _createTextVNode(" Atur Ulang ")
        ]),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "px-4 py-2 bg-transparent border-1 border-gray-300 rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, [
          _hoisted_18,
          _createTextVNode(" Batal ")
        ]),
        _createElementVNode("button", {
          disabled: !_ctx.canSubmit,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveEmail && _ctx.saveEmail(...args))),
          class: _normalizeClass(["px-4 py-2 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3", 
          _ctx.canSubmit ? 'bg-yellow-400 opacity-1' : 'bg-gray-400 opacity-30'
        ])
        }, [
          _hoisted_20,
          _createTextVNode(" Simpan ")
        ], 10, _hoisted_19)
      ])
    ])
  ], 64))
}